const getPatientDob3 = ({ patient, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }

  return patient['Date of Birth'].replace(/[/]/g, '').substring(6, 8);
};

export default getPatientDob3;



// WEBPACK FOOTER //
// ./src/utils/print/getPatientDob3.js